@if ((isLoading$ | async) !== true) {
  <ng-container *ngrxLet="tariff$; let tariff">
    <h1
      class="title"
      translate="register-account.title.settings"
      [translateParams]="{tariff: tariff.name}"
    ></h1>
    <app-account-settings
      (formSubmitted)="formSubmit($event, tariff)"
      (goBack)="goBack()"
      [currency]="selectedCurrency"
      [disableExceptPreSelectedServer]="!!selectedServer"
      [isIslamicCountry]="isIslamicCountry"
      [isSwapFreeContentVisible]="!tariff.isDemo && (isIslamicCountry || isSwapFreeAvailable)"
      [preSelectedServer]="selectedServer"
      [swapFreeDescription]="isIslamicCountry && !isTurkish
        ? 'register-account.alert.islamic'
        : 'register-account.alert.swapfree'
      "
      [tariff]="tariff"
    ></app-account-settings>
  </ng-container>
} @else {
  <app-loader class="compact" [isInner]="true">
    <div class="loader-desk" translate="register-account.label.loading-accounts"></div>
  </app-loader>
}

